import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApplicationService } from '../_services/application/application.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TopologyConfig, TopologyWithRoot } from '../_models/topology-list';
import { HomeComponent } from '../home/home.component';
import { LmService } from '../_services/lm-service/lm.service';
import { P } from '@angular/cdk/keycodes';
import { HttpResponse } from '@angular/common/http';
@Component({
  selector: 'app-live-monitoring-and-control',
  templateUrl: './live-monitoring-and-control.component.html',
  styleUrls: ['./live-monitoring-and-control.component.css']
})
export class LiveMonitoringAndControlComponent implements OnInit {

  percentageValue: string = '0';
  isFlexibilityControlToggled: boolean;
  public isLiveMonitoringAndControlButtonToggled : boolean;
  monitoringForm: FormGroup;
  // homeComponent: HomeComponent

  //variables from the Live Monitoring Window
  voltageThreshold: number;
  maxTrafoLoad: number;
  maxCableLoad: number;
  flexibilityControl: boolean;

  body=null;

  liveMonitoringParametersForm: FormGroup;

  private topologyId: TopologyConfig;

  inputFieldValues: { [key: string]: string} = {
    field1: '',
    field2: '',
    field3: ''
  };

  constructor(
    public activeModal: NgbActiveModal,
    private applicationService: ApplicationService,
    private formGroup: FormBuilder,
    private lmService: LmService

  ) {
    this.topologyId = JSON.parse(localStorage.getItem("currentTopology"));
    this.isFlexibilityControlToggled = this.lmService.isCMRunning(this.topologyId.topologyId);
    this.isLiveMonitoringAndControlButtonToggled = this.lmService.isLMRunning(this.topologyId.topologyId);
    // this.liveMonitoringParametersForm = new FormGroup({})
  }

  ngOnInit() {
    this.liveMonitoringParametersForm = this.formGroup.group({
      voltageThreshold: ['', [Validators.required]],
      maxTrafoLoad: ['', [Validators.required]],
      maxCableLoad: ['', [Validators.required]]
    });




    this.applicationService.getLmParameters(this.topologyId.topologyId).subscribe(response =>{
       console.log("@@"+response);
       if(response.flexibilityControl === true){
              console.log("@1@"+response.maxTrafoLoad);
              console.log("@2@"+response.maxCableLoad);
              console.log("@3@"+response.voltageThreshold);

        this.inputFieldValues["field2"] = response.maxTrafoLoad;
        this.inputFieldValues["field3"] = response.maxCableLoad;
        this.inputFieldValues["field1"] = response.voltageThreshold;

       }

    })


  }

  onInputFieldsChange(event: Event, key: string){
    const inputElement = event.target as HTMLInputElement;
    this.inputFieldValues[key] = inputElement.value;
    if(key === "field1")
      this.voltageThreshold = Number(inputElement.value);
    else if(key === "field2")
      this.maxTrafoLoad = Number(inputElement.value);
    else if(key === "field3")
      this.maxCableLoad = Number(inputElement.value);

  }
    private handleFileDownload(response: HttpResponse<Blob>): void {
      const blob = response.body;
      const filename = "CongestionManagementReport.txt";
      const contentType = blob.type;

      // Create blob url and initiate download
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style.display = 'none';
      a.href = downloadUrl;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(downloadUrl);
      document.body.removeChild(a);
    }

  downloadReport(){
    this.applicationService.downloadReport().subscribe(response =>{
      this.handleFileDownload(response);
    })
  }


  runMonitoring(){
    this.isLiveMonitoringAndControlButtonToggled = !this.isLiveMonitoringAndControlButtonToggled;
    // const formValues = this.monitoringForm.value;


    if(this.isLiveMonitoringAndControlButtonToggled){
      if(this.isFlexibilityControlToggled){
        this.body = {
          // topologyId: this.homeComponent.topologiesWithRoots[1].TopologyId,
          topologyId: this.topologyId.topologyId,
          voltageThreshold: this.voltageThreshold,
          maxTrafoLoad: this.maxTrafoLoad,
          maxCableLoad: this.maxCableLoad,
          flexibilityControl: this.isFlexibilityControlToggled
        }
      }else{
        this.body = {
          topologyId: this.topologyId.topologyId,
          voltageThreshold: null,
          maxTrafoLoad: null,
          maxCableLoad: null,
          flexibilityControl: this.isFlexibilityControlToggled
        }
      }
      this.applicationService.runLiveMonitoringAndControl(this.body).subscribe(response => {
        this.lmService.setLMRunning(this.topologyId.topologyId,true);
        this.lmService.setCMRunning(this.topologyId.topologyId,this.body.flexibilityControl);

        console.log("Response from backend when we RUN live monitoring and control" , response)
      });

    }else{
      this.body = {
        topologyId: this.topologyId.topologyId
      }
      this.applicationService.stopLiveMonitoringAndControl(this.body).subscribe(response => {
        this.lmService.setLMRunning(this.topologyId.topologyId,false);
        this.lmService.setCMRunning(this.topologyId.topologyId,false);
        this.isFlexibilityControlToggled = false;
        console.log("Response from backend when we STOP live monitoring and control" , response)
      })

      this.inputFieldValues = {
        field1: '',
        field2: '',
        field3: ''
      };

      localStorage.removeItem('field1'),
      localStorage.removeItem('field2'),
      localStorage.removeItem('field3')
    }
  }

  toggleFlexibilityControlButton(){
    this.isFlexibilityControlToggled = !this.isFlexibilityControlToggled;

    console.log("FLEXIBILITY CONTROL STATE? ", this.isFlexibilityControlToggled)

    if(this.isLiveMonitoringAndControlButtonToggled){
      this.body = {
        // topologyId: this.homeComponent.topologiesWithRoots[1].TopologyId,
        topologyId: this.topologyId.topologyId,
        voltageThreshold: this.voltageThreshold,
        maxTrafoLoad: this.maxTrafoLoad,
        maxCableLoad: this.maxCableLoad,
        flexibilityControl: this.isFlexibilityControlToggled
      }

      this.applicationService.runLiveMonitoringAndControl(this.body).subscribe(response => {
        this.lmService.setLMRunning(this.topologyId.topologyId,true);
        this.lmService.setCMRunning(this.topologyId.topologyId,this.body.flexibilityControl);
        console.log("Response from backend when we RUN live monitoring and control" , response)
      });
    }

    if(!this.isFlexibilityControlToggled){
      this.inputFieldValues = {
        field1: '',
        field2: '',
        field3: ''
      };

      localStorage.removeItem('field1'),
      localStorage.removeItem('field2'),
      localStorage.removeItem('field3')
    }
  }

  ngOnDestroy(){
    if(this.lmService.isLMRunning(this.topologyId.topologyId) && this.lmService.isCMRunning(this.topologyId.topologyId)){
      for(const key in this.inputFieldValues){
        if(this.inputFieldValues.hasOwnProperty(key)) {
          this.lmService.saveInputFieldValue(key, this.inputFieldValues[key]);
              if(key === "field1")
                this.voltageThreshold = Number(this.inputFieldValues[key]);
              else if(key === "field2")
                this.maxTrafoLoad =  Number(this.inputFieldValues[key]);
              else if(key === "field3")
                this.maxCableLoad = Number(this.inputFieldValues[key]);
        }
      }
    }
  }

}
